import { CoreProvider, usePublicConfig, type ApiClient } from '@pidelo/web-core';
import type { ComponentProps, ReactNode } from 'react';
import { UiConfigProvider } from '../../config/ui-config.tsx';
import { GlobalStyles } from '../GlobalStyles/GlobalStyles.tsx';
import { Toaster } from '../Toast/Toaster.tsx';

type QueryClient = ComponentProps<typeof CoreProvider>['queryClient'];

function PublicUiConfig({ children }: { children: ReactNode }) {
  const config = usePublicConfig();
  return (
    <UiConfigProvider rate={config.data?.rate.rate}>
      {children}
    </UiConfigProvider>
  );
}

/**
 * What both web apps mount at the root: the API client and the query cache, the styles, the rate
 * from `/v1/public/config`, and the notices.
 */
export function WebAppProviders({ client, queryClient, children }: { client: ApiClient; queryClient: QueryClient; children: ReactNode }) {
  return (
    <CoreProvider client={client} queryClient={queryClient}>
      <GlobalStyles />
      <PublicUiConfig>
        {children}
        <Toaster />
      </PublicUiConfig>
    </CoreProvider>
  );
}
